export default {
  displayName: 'Accordion',
  allowableParents: ['Section'],
};
